// Sticky Banner Manager - Handles dynamic positioning of banner and header.
// Layout model (required for sticky announcement + mega menu):
// - announcement: position fixed
// - body.paddingTop + headerGroup.top reserve/offset space so content is not covered
// - sticky header top sits below the fixed announcement while scrolling
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.announcement-bar-section');
  const headerGroup = document.querySelector('.shopify-section-group-header-group');

  const isStickyEnabled = banner?.classList.contains('announcement-bar-section--sticky');

  if (!isStickyEnabled || !banner || !headerGroup) {
    return;
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function updatePositions() {
    const stickyHeader =
      document.querySelector('.shopify-section-header-sticky') || document.querySelector('.section-header');
    const bannerHeight = banner.offsetHeight;
    const adjustedHeight = Math.ceil(bannerHeight) - 1;

    document.documentElement.style.setProperty('--sticky-banner-height', `${bannerHeight}px`);

    banner.style.position = 'fixed';
    banner.style.top = 0;
    banner.style.left = 0;
    banner.style.right = 0;
    banner.style.zIndex = 11; // Above header group (10)
    banner.style.width = '100%';
    banner.style.marginBottom = 0;
    banner.style.borderBottom = 'none';

    headerGroup.style.marginTop = 0;
    headerGroup.style.borderTop = 'none';

    // Push header group down by banner height (subtract 1px to prevent gap on mobile).
    // position:relative also keeps mega-menu stacking (header-group z-index: 3).
    headerGroup.style.position = 'relative';
    headerGroup.style.top = `${adjustedHeight}px`;

    if (stickyHeader) {
      stickyHeader.style.top = `${adjustedHeight}px`;
    }

    // Reserve viewport space for the fixed banner so main content (e.g. slim banner)
    // is not covered by sticky header / mega menu.
    document.body.style.paddingTop = `${Math.ceil(bannerHeight)}px`;

    // Collapse unused CLS spacer if present from earlier iterations.
    const spacer = document.querySelector('.announcement-bar-sticky-spacer');
    if (spacer) {
      spacer.style.height = '0px';
    }

    document.querySelector('sticky-header')?.scheduleHeaderOffsetUpdate?.();
  }

  updatePositions();

  window.addEventListener('resize', debounce(updatePositions, 150));
  document.addEventListener('sticky-banner:remeasure', debounce(updatePositions, 50));

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId.includes('top-banner')) {
        setTimeout(updatePositions, 100);
      }
    });

    document.addEventListener('shopify:section:reorder', function () {
      setTimeout(updatePositions, 100);
    });
  }
});
